import React, { useState, useEffect } from "react";
import { $api } from "../../../../../../helpers/$api";
import { Util } from "../../../../../../helpers/util";
import "./Portfolio.css";

const Portfolio = () => {
  const [balances, setBalances] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const balances = await $api.user.getBalances();

        setBalances(balances);
      } catch (error) {
        // error...
      }
    })();
  }, [setBalances]);

  const { currency } = Util.getCurrency();

  const {
    wallet_balance: ovest = 0,
    savest_total_balance: savestTotal = 0,
    total_savest_return: savestReturns = 0,
    total_amount_invested: investTotal = 0,
    total_investment_return: investReturns = 0,
  } = balances;
  const total = ovest + savestTotal + investTotal || 1;
  const ovestPercent = ((ovest / total) * 100).toFixed(2);
  const savestPercent = ((savestTotal / total) * 100).toFixed(2);
  const investPercent = ((investTotal / total) * 100).toFixed(2);

  return (
    <div className="portfolio-section">
      <div className="portfolio-header">
        <h1>Portfolio</h1>
      </div>
      <div className="portfolioColors">
        <div className="portfolio-blue" style={{ width: ` ${ovestPercent}%` }}>
          <p>{ovestPercent}%</p>
        </div>
        <div
          className="portfolio-darkBlue"
          style={{ width: `${savestPercent}%` }}
        >
          <p>{savestPercent}%</p>
        </div>
        <div className="portfolioBlue" style={{ width: `${investPercent}%` }}>
          <p>{investPercent}%</p>
        </div>
      </div>
      <div className="portfolio-savest">
        <div className="portfolio-text">
          <div className="wallets"></div>
          <p className="ml-3">Wallet</p>
        </div>
        <div className="portfolio-text ml-4">
          <div className="savest-color"></div>
          <p className="ml-3">Savest</p>
        </div>
        <div className="portfolio-text ml-4">
          <div className="invest-color"></div>
          <p className="ml-3">Invest</p>
        </div>
      </div>
      <div className="summarySection">
        <p className="summary-header">Portfolio Summary</p>
        <p className="summaryHeader">Wallet</p>
        <div className="summary-details">
          <div className="portfolio-summary">
            <p>Total wallet balance</p>
            <p>
              {currency}
              {(+ovest.toFixed(2)).toLocaleString()}
            </p>
          </div>
        </div>

        <p className="summaryHeader">Savings</p>
        <div className="portfolio-summary">
          <div className="summary-details">
            <p>Total savings balance</p>
            <p className="mt-2">Current returns</p>
          </div>
          <div className="summary-details">
            <p>{ currency}{(+savestTotal.toFixed(2)).toLocaleString()}</p>
            <p className="mt-2">
              { currency}{(+savestReturns.toFixed(2)).toLocaleString()}
            </p>
          </div>
        </div>
        <p className="summaryHeader">Investment</p>
        <div className="portfolio-summary">
          <div className="summary-details">
            <p>Total investment balance</p>
            <p className="mt-2">Current returns</p>
          </div>
          <div className="summary-detailss">
            <p>
              {currency}
              {(+investTotal.toFixed(2)).toLocaleString()}
            </p>
            <p className="mt-2 mb-5">
              {currency}
              {(+investReturns.toFixed(2)).toLocaleString()}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
